<template>
  <div class="componentSty">
    <m-title :titlelist="listitem"></m-title>
    <div class="componentSty_content">
      <div class="componentSty_content_title">
        <span class="fonints">时间选择</span>
        <el-date-picker
          v-model="conditions.yearMonthDay"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="请选择年月日"
        >
        </el-date-picker>
        <div class="cheboxSty">
          <el-radio-group
            v-model="conditions.statisticalMethods"
            @change="getTableMsg"
          >
            <el-radio label="代理统计">代理统计</el-radio>
            <el-radio label="计划统计">计划统计</el-radio>
            <el-radio label="流向统计">流向统计</el-radio>
          </el-radio-group>
        </div>
        <div class="cheboxSty">
          <el-radio-group v-model="radio" @input="checkboxChnage">
            <el-radio
              v-for="item in MyCheckboxList"
              :label="item.status"
              :key="item.name"
              >{{ item.name }}</el-radio
            >
          </el-radio-group>
        </div>
        <button class="buttons" @click="selectinfo">查询</button>
      </div>
      <div class="componentSty_content_table nogaoliang" >
        <el-table   :data="tabledata"  v-show="tabledata.length" :cell-style="cellStyle"  style="width: 100%;" height="80%">
           <el-table-column
            label="序号"
            type="index"
            width="50px"
          ></el-table-column>
          <template v-if="conditions.statisticalMethods == '代理统计'">
            <el-table-column prop="fleetName" label="代理名称">
            </el-table-column>
          </template>
          <template v-if="conditions.statisticalMethods == '计划统计'">
            <el-table-column prop="pno" label="计划编号"> </el-table-column>
          </template>
          <template v-if="conditions.statisticalMethods == '流向统计'">
            <el-table-column prop="flowName" label="流向名称">
            </el-table-column>
          </template>
          
          <el-table-column prop="completed" label="完成数"> </el-table-column>
          <el-table-column prop="dispatchedCarNumber" label="派车数">
          </el-table-column>
          <el-table-column prop="auditCarNumber" label="审核数">
          </el-table-column>
          <el-table-column prop="cancelCarNumber" label="取消车数">
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import mTitle from "@/components/mTitle";
import { antiShake } from "@/plugins/other.js";
import { mapMutations, mapState } from "vuex";
export default {
  data() {
    return {
      listitem: [{ name: "统计分析" }, { name: "进港统计" }],
      conditions: {},
      MyCheckboxList: [
        { name: "备货", status: "1" },
        { name: "提货", status: "2" },
        { name: "港内集疏", status: "3" }
      ],
      radio:'1',
      tabledata: [],
    };
  },
  computed: {
    ...mapState(["conditionsList"]),
  },
  created() {
    this.conditionsList[this.$route.path] ||
      this.createConditions({
        key: this.$route.path,
        val: {
          page: 1,
          limit: 20,
          statisticalMethods: "代理统计",
          paymentChannel2: [],
        },
      });
    this.conditions = this.conditionsList[this.$route.path] || {
      page: 1,
      limit: 20,
      statisticalMethods: "代理统计",
      paymentChannel2: [],
    };
  },
  components: {
    mTitle,
  },
  methods: {
    ...mapMutations(["createConditions"]),
    async getTableMsg() {
      if (!this.conditions.yearMonthDay)
        return this.$message.info("请选择日期");
      // this.conditions.paymentChannel = this.conditions.paymentChannel2 + "";
      this.conditions.plantype=this.radio
      const { data } = await this.$http(
        "api1",
        "/driver/dispatchtruck/dailyArrivalStatistics",
        "post",
        this.conditions
      );
      console.log(data)
      if (data.code != 0) return this.$message.error(data.msg);
      this.tabledata = data.data;
    },
    checkboxChnage(event){
       this.conditions.plantype=event;
      //  this.getTableMsg();
    },
    selectinfo() {
      antiShake((_) => {
        this.getTableMsg();
      });
    },
    rowStyle({row}){
      if(row.fleetName==="合计"){
        this.$refs.table.setCurrentRow()
      }
    },
    cellStyle({row, column, rowIndex, columnIndex}){
      if(row.fleetName==="合计"){ 
        if(columnIndex===0){
          return {color: "transparent",background:"#17B6A1"}
        }else{
          return {fontSize:"19px",color:"#ffff",background:"#17B6A1"}
        }
      }
    }
  },
};
</script>
<style lang="scss" src="@/assets/components.scss" scoped></style>
